/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CheckBox = _interopRequireDefault(require("../../CheckBox"));
var _join = _interopRequireDefault(require("../../../common/join"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultCheckedIcon = function defaultCheckedIcon(_ref) {
  var style = _ref.style,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  return _react.default.createElement("svg", {
    style: style,
    width: size,
    height: size,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }), _react.default.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "3",
    fillRule: "evenodd",
    stroke: "none"
  }));
};
var defaultUncheckedIcon = function defaultUncheckedIcon(_ref2) {
  var style = _ref2.style,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 16 : _ref2$size;
  return _react.default.createElement("svg", {
    style: style,
    width: size,
    height: size,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }));
};
var InovuaRadioButton = function (_Component) {
  (0, _inherits2.default)(InovuaRadioButton, _Component);
  var _super = _createSuper(InovuaRadioButton);
  function InovuaRadioButton() {
    var _this;
    (0, _classCallCheck2.default)(this, InovuaRadioButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNativeBrowserInput", function (config) {
      if (props.renderNativeBrowserInput) {
        return renderNativeBrowserInput(config);
      }
      config.inputProps.type = 'radio';
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var props = _this.props;
      var checkedIcon = defaultCheckedIcon || props.checkedIcon;
      var uncheckedIcon = defaultUncheckedIcon || props.uncheckedIcon;
      var className = (0, _join.default)("".concat(props.rootClassName), props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme));
      var checkboxProps = _objectSpread(_objectSpread({}, props), {}, {
        className: className,
        checkedIcon: checkedIcon,
        uncheckedIcon: uncheckedIcon,
        renderNativeBrowserInput: _this.renderNativeBrowserInput
      });
      return _react.default.createElement(_CheckBox.default, _objectSpread({}, checkboxProps));
    });
    return _this;
  }
  return (0, _createClass2.default)(InovuaRadioButton);
}(_react.Component);
InovuaRadioButton.defaultProps = {
  theme: 'default-light',
  rootClassName: 'inovua-react-toolkit-radio-button'
};
InovuaRadioButton.propTypes = {
  theme: _propTypes.default.string,
  rootClassName: _propTypes.default.string
};
var _default = InovuaRadioButton;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/RadioButton/src/RadioButton.js
// module id = 742
// module chunks = 0